<template>
    <div class="mainbody modulewrap">
        <div class="banner">
            <div class="bannerimg"><img :src="pageinfo.banner" /></div>
        </div>
        <div class="navinfowconrap">
            <div class="navinfocon realwrap editor2" v-html="$common.langinfo(pageinfo.content,pageinfo.content_en)"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'contact',
        data() {
            return {
                pageinfo: {},
            };
        },
        mounted() {

            this.$common.fetch({ 'act': 'tc_topnavinfo', 'exts': 'id=5' }, res => {
                this.pageinfo = res.infodata;
            });
        }
    }
</script>
